'use strict';
/**
 * Turns a browser readable stream into an async iterable. Async iteration over
 * returned iterable will lock give stream, preventing any other consumer from
 * acquiring a reader. The lock will be released if iteration loop is broken. To
 * prevent stream cancelling optional `{ preventCancel: true }` could be passed
 * as a second argument.
 * @template T
 * @param {ReadableStream<T>} stream
 * @param {Object} [options]
 * @param {boolean} [options.preventCancel=boolean]
 * @returns {AsyncIterable<T>}
 */

var _regeneratorRuntime = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _awaitAsyncGenerator = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

function browserReadableStreamToIt(_x) {
  return _browserReadableStreamToIt.apply(this, arguments);
}

function _browserReadableStreamToIt() {
  _browserReadableStreamToIt = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream) {
    var options,
        reader,
        result,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            reader = stream.getReader();
            _context.prev = 2;

          case 3:
            if (!true) {
              _context.next = 13;
              break;
            }

            _context.next = 6;
            return _awaitAsyncGenerator(reader.read());

          case 6:
            result = _context.sent;

            if (!result.done) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return");

          case 9:
            _context.next = 11;
            return result.value;

          case 11:
            _context.next = 3;
            break;

          case 13:
            _context.prev = 13;

            if (options.preventCancel !== true) {
              reader.cancel();
            }

            reader.releaseLock();
            return _context.finish(13);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2,, 13, 17]]);
  }));
  return _browserReadableStreamToIt.apply(this, arguments);
}

module.exports = browserReadableStreamToIt;